(function($, window, document) {
    $(function() {
        App.init();
    });
}(window.jQuery, window, document));

var App = {
    /**
     * Initialise the application
     */
    init: function() {
        App.protectCSRF();
        // Fix layout on initial load and window resize
        App.fixLayout();

        $(window).on('resize', function() {
            App.fixLayout();
        });
        // Bind UI elements
        App.bindToggleMobileNavigation();
        App.bindSidePanelButtons();
        App.initSwitchery();
        App.initCollapsible();
        App.initZoom();
        App.initDatepicker();
        App.initClickableTables();
        App.initSelect2();
        App.initTabs();
        App.initSortable();
        App.initDeleteConfirm();
        App.initProfileBarButtons();
        App.bindSelectAll();
        App.initEvidenceGallery();
        App.bindAddItem();
        App.bindAddSubItem();
        App.bindRemoveItem();
        App.bindPupilFilter();
        App.bindProgressButtons();
        App.bindProgressForms();
        App.bindResizeTextArea();
        App.bindProcessWait();

        App.initSortableDiv();

        App.bindClickFrameworkTab();
        App.bindClickLevelEdit();
        App.bindClickSubjectEdit();

        Forms.bindImageFields();
        Forms.bindDropzones();

        Assessment.init();
        Iep.init();
        Engagements.init();
        Incidents.init();
        Progression.init();
        Frameworks.init();
        CustomFields.init();
        Reports.init();
        Clm.init();

        OutcomesProgress.init();

        Interventions.init();

        Lists.bindAssessmentFrameworkSearch();
        Lists.bindAdditionalSubjectSearch();

        Teachers.bindSearchSelect();
        Teachers.bindAdditionalPupilSearch();

        Pupils.bindSearchSelect();

        Schools.bindSearchSelect();

        if ($('#rfl-tutor-groups').length > 0 ) {
            Rfl.init();
        }

        Levels.init();

        AllAboutMe.init();
        CommunicationProfile.init();
        MealTimePlans.init();
        KeySkills.init();
        RiskAssessment.init();
        BehaviourProfile.init();
        /* needed to move this up (under Iep.init())
        Engagements.init();
        */
        Soladmin.init();

        //App.bindEmailForm();
        //App.bindEmailFormButton();

        LearningOutcomes.init();
        Peep.init();
    },

    bindProgressForms: function() {
        $('.progress-form').submit(function() {
            var form = $(this);
            var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
            form.find("button[type='submit']").html(html).attr('disabled', true);
        });
    },

    bindProgressButtons: function() {
        // $('.progress-button').click(function(e) {
        //     var button = $(this);
        //     var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
        //     button.html(html).attr('disabled', true);
        // });
    },

    bindAddItem: function() {
        $('.add-item').click(function() {
            var type = $(this).data('type');
            var count = $('.item').length;
            var items = $('#items');

            $.get('/' + type + '/ajax?count=' + count, function(data) {
                $('#add-container').remove();
                items.append(data);
                $('.select2').select2();
                App.bindAddItem();
                App.bindRemoveItem();
                App.bindItemFeatures(type);
                if (type == 'outcomes-progress') {
                    App.bindAddSubItem();
                }
            });
        });
    },

    bindAddSubItem: function() {
        //$('.add-subItem').click(function() {
        $('select[id^="target-select-"]').on('change', function() {
            var type = $(this).data('type');
            var itemId = $(this).data('itemid');
            var count2 = $('div[id^="subItem-'+itemId+'"]').length;
            var subItems = $('div[id^="subItems-'+itemId+'"]');
            //var itemId = subItems.data('itemid');
            var topicId = $(this).find(":selected").val();

            $.get('/' + type + '/ajax2?count2=' + count2 + '&itemId=' + itemId + '&topicId=' + topicId, function(data) {
                $('#add-container2').remove();
                subItems.append(data);
                $('.select2').select2();
                App.bindAddSubItem();
                App.bindRemoveSubItem();
                //App.bindSubItemFeatures(type);
            });
        });
    },

    bindItemFeatures: function(type) {
        if (type == 'key-skills') {
            KeySkills.bindSubjectSelect();
        }
    },

    bindRemoveItem: function() {
        $('.btn-remove-item').off('click').on('click', function() {
            var btn = $(this);
            var items = $('.item');
            var itemCount = items.length;
            if (itemCount > 1) {
                $('.item:last').remove();
                itemCount--;
            }
            if (itemCount == 1 || itemCount == existingItems) {
                $('.btn-remove-item').addClass('hidden');
            }
            // if ((typeof existingItems !== 'undefined' && targetCount > existingItems) || targetCount > 1) {
            //     iepTargets.last().remove();
            //     targetCount--;
            // }
            // if ((typeof existingItems !== 'undefined' && targetCount > existingItems) || targetCount == 1) {
            //     $('.btn-remove-target').addClass('hidden');
            // }
        });
    },

    bindRemoveSubItem: function() {
        $('.btn-remove-subItem').off('click').on('click', function() {
            var btn = $(this);
            var subItems = $('.subItem');
            var subItemCount = subItems.length;
            if (subItemCount > 1) {
                $('.subItem:last').remove();
                subItemCount--;
            }
            if (subItemCount == 1 || subItemCount == existingSubItems) {
                $('.btn-remove-subItem').addClass('hidden');
            }
        });
    },

    bindPupilFilter: function() {
        $('.filter-pupil').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Pupil Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function(e) {
            var type = $(this).data('type');
            console.log(type);
            if (type != 'assessments') {
                window.location.href = '/' + type + '?pupil=' + $(this).select2('data')[0].id;
            } else {
                var query = window.location.search;
                query = query.replace(/(\?|\&)search_pupil_id=\d+/, '');
                window.location.search = query + (query == '' ? '?' : '&') +
                    'search_pupil_id=' + $(this).select2('data')[0].id;
            }
        });
    },

    sortProperties: function(obj, isNumericSort) {
        isNumericSort=isNumericSort || false; // by default text sort
        var sortable=[];
        for(var key in obj)
            if(obj.hasOwnProperty(key))
                sortable.push([key, obj[key]]);
        if(isNumericSort)
            sortable.sort(function(a, b)
            {
                return a[1]-b[1];
            });
        else
            sortable.sort(function(a, b)
            {
                var x=a[1].toLowerCase(),
                    y=b[1].toLowerCase();
                return x<y ? -1 : x>y ? 1 : 0;
            });
        return sortable; // array in format [ [ key1, val1 ], [ key2, val2 ], ... ]
    },

    fillSelect: function(dataUrl, targetId) {
        $.get(dataUrl, function(data) {
            if (!data.success) {
                alert('Action not successful, please try again.');
                return false;
            }
            var select = $('#' + targetId);
            select.empty();
            var pupils = App.sortProperties(data.items);
            for (var x = 0; x < pupils.length; x++) {
                var pupil = pupils[x];
                var id = pupil[0];
                var name = pupil[1];
                var item = '<option value="'+ id +'">' + name + '</option>';
                select.append(item);
            };
        });
    },

    /**
     * Fix bottom navigation icons to bottom of screen and resize columns to be 100% height
     * @todo: This (obviously) doesn't work properly on mobile yet
     */
    fixLayout: function() {
        if ($(window).width() <= 480) {
            $('.icon-nav').hide();
            $('.main').show();
            $('.sidebar-row .icon-nav, .secondary-nav').hide();
            $('.container-fluid, body').removeClass('fill-bg');
            return false;
        }

        $('.icon-nav').css('top', '40px').show();
        $('.main').show();
        $('.sidebar-row .icon-nav, .secondary-nav').show();
        $('#icon-nav, #secondary, #side').height(($(window).height() - 41));

        //var secHeight = $('.secondary-nav:first').height();
        var secondaryNav = $('#secondary');
        var secondaryNavHeight = secondaryNav.height();
        var side1 = $('#side-1');
        var s1h = side1.height();
        //var s2h = $('#side-2').height();
        $('#side-2').height(secondaryNavHeight);
        $('.secondary-nav').find('.select2').data('width', '100%');

        if (s1h < secondaryNavHeight) {
            //console.log('secHeight: ' + secondaryNavHeight);
            $('#side-1').height(secondaryNavHeight);
            //s1h = secondaryNavHeight;
            //s1h = secondaryNavHeight;
        }

        var windowHeight = $(window).height();
        var rflHeight =  windowHeight / 1.06;
        var clmOffset = windowHeight / 50;
        //var clmHeight = (windowHeight / 1.06);
        var clmHeight = rflHeight;
        $('#rfl-container').height(rflHeight);
        $('#clm-content').height(clmHeight);

        //if (s2h < s1h) {
        //.css('position', 'fixed').css('right', 0).css('width', '14%').css('overflow-y', 'scroll');
        //}
    },

    /**
     * Init the faux Bootstrap collapse
     * This is currently faked due to some bugs in the .alpha-2 collapse functionality
     *
     * @todo Redo this using Bootstrap collapse
     * @see http://v4-alpha.getbootstrap.com/components/collapse/
     */
    initCollapsible: function() {
        $('.accordion.active').next('.collapse').show();
        $('.accordion').on('click', function(e) {
            e.preventDefault();
            var $parent = $(this).parent();

            // if ($(this).next('.collapse').is(':visible')) {
            //     console.log('visible');
            //     $(this).removeClass('active').addClass('inactive');
            //     $(this).next('.collapse').slideUp('fast');
            // } else {
            //     console.log('invisible');
            //     $parent.find('.accordion').removeClass('active').addClass('inactive');
            //     $(this).removeClass('inactive').addClass('active');
            //     $parent.find('.inactive').next('.collapse').slideUp('fast');
            //     $parent.find('.active').next('.collapse').slideDown('fast');
            // }

            var nearestCollapse = $(this).next('.collapse');
            if (nearestCollapse.is(':hidden') || nearestCollapse.children().length <= 0) {
                $parent.find('.accordion').removeClass('active').addClass('inactive');
                $(this).removeClass('inactive').addClass('active');
                $parent.find('.inactive').next('.collapse').slideUp('fast');
                $parent.find('.active').next('.collapse').slideDown('fast');
            } else {
                $(this).removeClass('active').addClass('inactive');
                $(this).next('.collapse').slideUp('fast');
            }
            //App.fixLayout(); // Need to fix the layout again as heights will have changed
        });
    },

    /**
     * Initialize Switchery to change checkboxes into iOS-style switches
     * @see http://abpetkov.github.io/switchery/
     */
    initSwitchery: function() {
        if ($('.switchery').length > 0) {
            var elems = Array.prototype.slice.call(document.querySelectorAll('.switchery'));

            elems.forEach(function(html) {
                var switchery = new Switchery(html, { color: '#04db5e'});
            });
        }
    },

    /**
     * Init the Bootstrap-styled datapicker
     * @see http://bootstrap-datepicker.readthedocs.io/en/v1.6.1/
     */
    initDatepicker: function() {
        $('.audit-datepicker, .iep-datepicker, ' +
            '.all-about-me-datepicker, .communication-profile-datepicker, .meal-time-plans-datepicker, .risk-assessment-datepicker, ' +
            '.behaviour-profile-datepicker, .engagements-datepicker, .learning-outcomes-datepicker, .peep-datepicker')
            .datepicker({
                format: 'dd/mm/yyyy',
                autoclose: true,
                todayBtn: 'linked', // Show a 'Today' button at the bottom, selecting it selects the current date
                weekStart: 1, // Start weeks on Monday,
            });

        $('.date .datepicker').datepicker({
            format: 'D d MM yyyy',
            autoclose: true,
            todayBtn: 'linked', // Show a 'Today' button at the bottom, selecting it selects the current date
            weekStart: 1, // Start weeks on Monday,
        });

        $('.term-datepicker').datepicker({
            format: 'dd/mm/yyyy',
            autoclose: true,
            weekStart: 1, // Start weeks on Monday,
        });

        var today = new Date();
        $('.starcard-date').datepicker({
            format: 'D d MM yyyy',
            autoclose: true,
            endDate: "today",
            maxDate: today
        });

        $('.add-pupil-date').datepicker({
            format: 'dd/mm/yyyy',
            autoclose: true,
            /* allow future date on roll
            endDate: "today",
            maxDate: today
            */
        });

        $('.level-datepicker').datepicker({
            format: 'dd/mm/yyyy',
            autoclose: true,
            endDate: "today",
            maxDate: today
        });
    },

    /**
     * Bind the side panel show/hide
     */
    bindSidePanelButtons: function() {
        $('#hide-side-panel-button').on('click', function() {
            $('.side').toggle();
            $('#side-1').attr('class', 'col-xl-24 col-lg-24 col-md-24 p-l-0 p-r-0');
            $('#hide-side-panel-button').hide();
            $('#show-side-panel-button').show();
        });

        $('#show-side-panel-button').on('click', function() {
            $('.side').toggle();
            $('#side-1').attr('class', 'col-xl-20 col-lg-18 col-md-18 p-l-0 p-r-0');
            $('#show-side-panel-button').hide();
            $('#hide-side-panel-button').show();
        });
    },

    /**
     * Bind the mobile navigation toggling
     */
    bindToggleMobileNavigation: function() {
        $('.toggle-mobile-navigation').on('click', function(e) {
            e.preventDefault();
            if ($('.main').is(':visible')) {
                $('.main').hide();
                $('.icon-nav').css('min-width', '80px').css('top', '80px').show();
                $('.secondary-nav').show();
                $('.container-fluid, body').addClass('fill-bg');
            } else {
                $('.main').show();
                $('.icon-nav').hide();
                $('.secondary-nav').hide();
                $('.container-fluid, body').removeClass('fill-bg');
            }
        });
    },

    /**
     * Init clickable table rows
     */
    initClickableTables: function() {
        $('table.clickable > tbody > tr').click(function() {
            if ($(this).data('href')) {
                window.location.href = $(this).data('href');
            }
        });

        $('.dropdown-toggle').click(function(e) {
            e.stopPropagation();
            var parent = $(this).parent();
            if (parent.hasClass('show')) {
                parent.removeClass('show');
            } else {
                $(this).parent().addClass('show');
            }
        });
    },

    /**
     * Init zoom on images
     */
    initZoom: function() {
        $('.zoom').elevateZoom({
            zoomType: 'lens',
            lensShape: 'round',
            lensSize: 200
        });
    },

    /**
     * Init select2
     */
    initSelect2: function() {
        $('select.select2').select2();
        Frameworks.bindFlightPathAdd();
        Frameworks.bindFlightPathSelects();
    },

    /**
     * Init Bootstrap tabs
     */
    initTabs: function() {
        if (window.location.hash.length > 0) {
            var hash = window.location.hash;
            var scrollmem = $('body').scrollTop() || $('html').scrollTop();
            $('a.nav-link[href="' + hash + '"]').click();
            $('html, body').scrollTop(0);
        }

        $('.nav-tabs a').click(function (e) {
            $(this).tab('show');
            var scrollmem = $('body').scrollTop() || $('html').scrollTop();
            window.location.hash = this.hash;
            $('html, body').scrollTop(0);
        });

        $('.frmwk-delete-warn').click(function() {
            if (confirm('Last Warning: clicking OK will delete all levels, subjects, statements and assessment on the assessment framework.')) {
                var url = $(this).attr('href');
                //$('#content').load(url);
                //window.open(url);
                location.href = url;
            }
            return false;
        });

    },

    initSortable: function() {
        /* bind update event after sortable initialisation to execute manually
        $('.sortable').sortable({
            axis: 'y',
            handle: 'i.handle',
            items: 'tr',
            update: function() {
                $.post($(this).data('href'), {
                    data: $(this).sortable('toArray', {attribute: 'data-id'})
                }, function() {
                });
            }
        });
        */
        $('.sortable').sortable({
            axis: 'y',
            handle: 'i.handle',
            items: 'tr',
        });
        $('.sortable').on('sortupdate', function() {
            $.post($(this).data('href'), {
                data: $(this).sortable('toArray', {attribute: 'data-id'})
            }, function() {
            });
        });
    },

    initSortableDiv: function() {
        $('.sortable-div').sortable({
            axis: 'y',
            handle: 'i.handle',
            items: 'div.movable',
            update: function() {
                $.post($(this).data('href'), {
                    data: $(this).sortable('toArray', {attribute: 'data-id'})
                }, function() {
                });
            }
        });
    },

    protectCSRF: function() {
        $.ajaxSetup({
            headers: { 'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content') }
        });
    },

    initDeleteConfirm: function() {
        console.log('binding delete');
        $('a[data-confirm]:not(.set-statement-na)').click(function(e) {
            if (!confirm($(this).data('confirm'))) {
                e.preventDefault();
            }
        });
    },

    initProfileBarButtons: function() {
        $('.print').on('click', function(e) {
            e.preventDefault();
            var originalHeights = [];
            $('.print-expand-textarea').each(function() {
                var textArea = $(this);
                var id = textArea.attr('id');
                var increase = $(this).data('increase');


                //originalHeights[id] = textArea.attr('height');
                //var charCount = textArea.text().split(' ').length;
                //var charCount = textArea.text().length;
                //var height = textArea[0].scrollHeight + 50;
                //var height = charCount + increase;
                var rows = parseInt(textArea.attr('rows'));
                var newRows = rows + parseInt(rows/2.5 + 2.5) ;
                originalHeights[id] = rows;
                textArea.attr('rows', newRows);
            });
            $('.shaped-text').each(function () {
                var height = parseInt(this.scrollHeight) * (41 / 16);
                this.setAttribute("style", "height:" + height + "px;overflow-y:hidden;");
            });
            window.print();
            console.log(originalHeights);
            $('.print-expand-textarea').each(function() {
                var textArea = $(this);
                var id = textArea.attr('id');
                var originalHeight = originalHeights[id];
                //textArea.height(originalHeight);
                textArea.attr('rows', originalHeight);
            });
            $('.shaped-text').each(function () {
                var height = parseInt(this.scrollHeight) / (41 / 16);
                this.setAttribute("style", "height:" + height + "px;overflow-y:hidden;");
            });
            return false;
        });

        $('.print-side-1').on('click', function(e) {
            e.preventDefault();
            var restorepage = $('body').html();
            var printcontent = $('#side-1').clone();
            $('body').empty().html(printcontent);
            window.print();
            $('body').html(restorepage);
            return false;
        });

        App.zoomLevel = 1;

        $('.increase').click(function(e) {
            e.preventDefault();
            App.updateZoom(0.1);
        });

        $('.decrease').click(function(e) {
            e.preventDefault();
            App.updateZoom(-0.1);
        });
    },

    updateZoom: function(zoom) {
        App.zoomLevel = App.zoomLevel + zoom;
        $('body').css({ zoom: App.zoomLevel, '-moz-transform': 'scale(' + App.zoomLevel + ')' });
    },

    bindSelectAll: function() {
        $("#select-all").change(function () {
            $("input[name^='tutorGroup']:checkbox").prop('checked', $(this).prop("checked"));
        });
    },

    initEvidenceGallery: function() {
        $('.gallery li').click(function() {
            var speed = 100;
            var first = $(this).parent().children(':first'),
                next = $(this).next();
            next = next.index() == -1 ? first : next;
            $(this).fadeOut(speed, function() {next.fadeIn(speed);});

        });
    },

    bindResizeTextArea: function() {
        /*
        $('.textarea-content').on('change keyup keydown paste cut', 'textarea', function () {
            $(this).height(0).height(this.scrollHeight);
        }).find('textarea').change();
        */
        // $(document).ready(function() {
        //     $('.textarea-content').each(function() {
        //         $(this).height(0).height(this.scrollHeight).blur();
        //     });
        // })
        $('.expand-textarea').each(function() {
            var textArea = $(this);
            //var scrollHeight = textArea[0].scrollHeight;
            // var newHeight = scrollHeight + 10;
            // textArea.attr('height', newHeight + 4);
            // textArea.height(newHeight);
            var text = textArea.val();
            var textArray = text.split('\n');
            var lineCount = textArray.length;
            var rows = lineCount;
            var cols = textArea.attr('cols');

            for (i = 0; i < lineCount; i++) {
                var textLength = textArray[i].length;
                rows += parseInt(textLength / (cols * 4));
            }

            textArea.attr('rows', rows);
        });
    },

    bindProcessWait: function() {
        $('.process-wait').on('click', function(e) {
            if (window.MutationObserver) {
                //var waitText = $('#wait-text');
                //var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
                //waitText.prepend(html);
                $('#wait-overlay').show();
            }
        });
    },

    bindClickFrameworkTab: function() {
        $('.nav-tabs a').on('click', function() {
            //alert(this.hash);
            var clicked = this.hash;
            var deleteTab = $('.nav-item a[href="#delete"]');
            if (!deleteTab.is(":hidden")) {
                if (clicked != '#setup') {
                    deleteTab.hide();
                }
            } else {
                if (clicked == '#setup') {
                    deleteTab.show();
                }
            }
        });
    },

    bindClickLevelEdit: function() {
        $('a.edit-level').on('click', function() {
            //alert(this.hash);
            var deleteTab = $('.nav-item a[href="#delete"]');
            deleteTab.hide();
        });
    },

    bindClickSubjectEdit: function() {
        $('a.edit-subject').on('click', function() {
            //alert(this.hash);
            var deleteTab = $('.nav-item a[href="#delete"]');
            deleteTab.hide();
        });
    },
};